import { Button, useTheme } from "cambrian-ds";
import { Moon, Sun } from "lucide-react";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <Button
      onPress={() => setTheme(theme === "dark" ? "light" : "dark")}
      size="sm"
      variant="tertiary"
      isIconOnly
      className="p-2 rounded-lg hover:bg-cambrian-border-light/50 dark:hover:bg-gray-800"
    >
      {theme === "light" ? (
        <Sun className="h-4 w-4" />
      ) : (
        <Moon className="h-4 w-4" />
      )}
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
